// extracted by mini-css-extract-plugin
export var measureBox = "_5b-0";